import {AceLoggerService } from '@logging/ace-logger.service';
import {inject, Injectable} from '@angular/core';
import {BaseService} from '../base-service';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {NetworkProviderPlanPeriodType} from '../access-sites.interface';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {AceLogger} from '@logging/ace-logger';
import {APIResponse} from '@app/layout/admin/services/api/api.interface';
import {HttpUtilityService} from '@shared/services/api/http-utility-service';

export const networkProviderPlanPeriodTypesResolver: ResolveFn<NetworkProviderPlanPeriodType[]> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<NetworkProviderPlanPeriodType[]> => {
  return inject(NetworkProviderPlanPeriodTypesService).getNetworkProviderPlanPeriodTypes();
};

@Injectable({
  providedIn: 'root'
})
export class NetworkProviderPlanPeriodTypesService extends BaseService {

  private readonly URL_PART = '/network-providers/plans/period-types';
  private readonly DATA_KEY_PLURAL = 'network_provider_plan_period_types';
  private readonly logger: AceLogger;
  
  constructor(private http: HttpClient,
              private httpUtilityService: HttpUtilityService,
              logService: AceLoggerService) {
    super();
    this.logger = logService.create(NetworkProviderPlanPeriodTypesService.name);
  }

  public getNetworkProviderPlanPeriodTypes(): Observable<NetworkProviderPlanPeriodType[]> {
    const options = {headers: this.getHeaders()};
    return this.http.get(this.getGateway() + this.URL_PART, options)
      .pipe(map((response: APIResponse<NetworkProviderPlanPeriodType[]>) => this.httpUtilityService.extractResponseData(response, this.DATA_KEY_PLURAL)));
  }

}
